var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 95.131,
  height: 96,
  viewBox: "0 0 95.131 96"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "India",
  transform: "translate(-512.469 -358)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5367",
  "data-name": "Group 5367",
  transform: "translate(0.72)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_357",
  "data-name": "Path 357",
  d: "M269.492,32.972l29.77-.03a.346.346,0,0,0-.015-.042A47.862,47.862,0,0,0,258.292,1.167C265.65,5.22,267.612,17.866,269.492,32.972Z",
  transform: "translate(305.017 357.028)",
  fill: "#e97e24"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_360",
  "data-name": "Path 360",
  d: "M13.548,31.959c0,.014-.009.027-.015.042H76.57C74.7,16.987,70.112,4.226,62.808.2,61.4.072,59.967,0,58.522,0A47.745,47.745,0,0,0,13.548,31.959Z",
  transform: "translate(500.747 357.999)",
  fill: "#ea8634"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5369",
  "data-name": "Group 5369"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_376",
  "data-name": "Path 376",
  d: "M0,173.968a48.837,48.837,0,0,0,2.557,15.911l63.037-.007a135.426,135.426,0,0,0-.023-32l-63,.005A48.713,48.713,0,0,0,0,173.968Z",
  transform: "translate(512.469 232.128)",
  fill: "#efefef"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_375",
  "data-name": "Path 375",
  d: "M341.624,157.84l-26.97.026a144.539,144.539,0,0,1,0,32l26.94.046a50.624,50.624,0,0,0,.026-32.075Z",
  transform: "translate(263.382 232.127)",
  fill: "#efecec"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5368",
  "data-name": "Group 5368",
  transform: "translate(515 422)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_357-2",
  "data-name": "Path 357",
  d: "M269.492,1.167l29.77.03a.346.346,0,0,1-.015.042,47.862,47.862,0,0,1-40.956,31.732C265.65,28.919,267.612,16.274,269.492,1.167Z",
  transform: "translate(-209.263 -1.167)",
  fill: "#258f44"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_360-2",
  "data-name": "Path 360",
  d: "M13.548.043c0-.014-.009-.027-.015-.042H76.57C74.7,15.015,70.112,27.776,62.808,31.8c-1.413.126-2.841.2-4.286.2A47.745,47.745,0,0,1,13.548.043Z",
  transform: "translate(-13.533 -0.001)",
  fill: "#359846"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5366",
  "data-name": "Group 5366",
  transform: "translate(542.181 388.181)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_344",
  "data-name": "Ellipse 344",
  transform: "translate(3.219 3.819)",
  fill: "none",
  stroke: "#0058d6",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 13,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5354",
  "data-name": "Group 5354",
  transform: "translate(5.219 5.219)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1",
  "data-name": "Line 1",
  y2: 25.2,
  transform: "translate(12.6)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2",
  "data-name": "Line 2",
  y2: 25.2,
  transform: "translate(25.2 12.6) rotate(90)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5355",
  "data-name": "Group 5355",
  transform: "translate(17.819 0) rotate(45)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1-2",
  "data-name": "Line 1",
  y2: 25.2,
  transform: "translate(12.6 0)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2-2",
  "data-name": "Line 2",
  y2: 25.2,
  transform: "translate(25.2 12.6) rotate(90)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5356",
  "data-name": "Group 5356",
  transform: "translate(24.494 1.298) rotate(67)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1-3",
  "data-name": "Line 1",
  y2: 25.2,
  transform: "translate(12.6 0)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2-3",
  "data-name": "Line 2",
  y2: 25.2,
  transform: "translate(25.2 12.6) rotate(90)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5357",
  "data-name": "Group 5357",
  transform: "matrix(-0.391, 0.921, -0.921, -0.391, 34.34, 11.144)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1-4",
  "data-name": "Line 1",
  y2: 25.2,
  transform: "translate(12.6 0)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_2-4",
  "data-name": "Line 2",
  y2: 25.2,
  transform: "translate(25.2 12.6) rotate(90)",
  fill: "none",
  stroke: "#0e58d6",
  strokeLinecap: "round",
  strokeWidth: 2
}))))));
export default __webpack_public_path__ + "static/media/indiaflag2.38304227.svg";
export { SvgComponent as ReactComponent };